import { defineMessages } from 'react-intl'

export default defineMessages({
  helpLabel: {
    id: 'accountSettings.helpPoliciesSection.helpLabel',
    defaultMessage: 'Help',
  },
  privacyStatementLabel: {
    id: 'accountSettings.helpPoliciesSection.privacyLabel',
    defaultMessage: 'Privacy statement',
  },
  aboutHeading: {
    id: 'accountSettings.helpPoliciesSection.aboutHeading',
    defaultMessage: 'Help & Policies',
  },
})
